<template>
  <div class="qn-status-tag" :class="color!=='cmain'?'qn-status-tag-'+color:''">
    <div class="qn-triangle" :class="color!=='cmain'?'qn-triangle-'+color:''">
    </div>
    <div class="qn-rectangle pl20 pr8" :class="color!=='cmain'?'qn-rectangle-'+color:''">
      <slot></slot>
      <!-- <span class="ft12 cmain">{{ status | nameArrConstantFilter(Constants.BASIC_AUDIT_STATUS) }}</span> -->
    </div>
  </div>
</template>
<script>
import Constants from '@/constants'
export default {
  props: {
    status: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      Constants
    }
  },
  mounted () {
    this.$nextTick(res => {

    })
  }
}
</script>
<style lang="less" scoped>
@import '../../styles/var.less';

.qn-status-tag{
  position: relative;
  &::before{
    position: absolute;
    content: "";
    display: block;
    width: 9px;
    height: 9px;
    top: 7px;
    left: 4px;
    z-index: 2;
    border-radius: 50%;
    border: 1px solid @main-color;
    background-color: #fff;
  }
  .qn-triangle{
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 6px;
    border-top: 1px solid @main-color;
    border-left: 1px solid @main-color;
    background-color: @main-light-color;
    transform: rotate(-45deg);
    top: 2px;
    left: -5px;
  }
  .qn-rectangle{
    height: 24px;
    padding-left: 20px;
    padding-right: 8px;
    border-top: 1px solid @main-color;
    border-right: 1px solid @main-color;
    border-bottom: 1px solid @main-color;
    border-radius: 6px;
    background-color: @main-light-color;
  }
}
.qn-status-tag-yellow{
  &::before{
    border-color: @yellow;
  }
  .qn-triangle-yellow,.qn-rectangle-yellow{
    border-color: @yellow;
    background-color: @light-yellow;
  }
}
.qn-status-tag-red{
  &::before{
    border-color: @red;
  }
  .qn-triangle-red,.qn-rectangle-red{
    border-color: @red;
    background-color: @light-red;
  }
}
.qn-status-tag-green{
  &::before{
    border-color: @green;
  }
  .qn-triangle-green,.qn-rectangle-green{
    border-color: @green;
    background-color: @light-green;
  }
}
.qn-status-tag-blue{
  &::before{
    border-color: @blue;
  }
  .qn-triangle-blue,.qn-rectangle-blue{
    border-color: @blue;
    background-color: @light-blue;
  }
}
</style>
